import { useEffect, useState } from "react";
import ContentHeader from "../components/ContentHeader";
import Filter from "../components/Filter";
import Table from "./components/Table";
import { useDispatch, useSelector } from "react-redux";
import { profileTeams } from "actions/teams";

const Teams = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const [teamsList, setTeamsList] = useState([]);
  const [team, setTeam] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [filterResult, setFilterResult] = useState([]);
  const [employeesPhotos, setEmployeesPhotos] = useState(new Map());

  const teamsData = useSelector((state) => state.teams);

  useEffect(() => {
    dispatch(profileTeams);
  }, [dispatch]);

  useEffect(() => {
    const teamsArray = [];

    teamsData?.map(({ name, team_members }) => {
      return teamsArray.push({
        label: name,
        value: name,
        members: team_members,
      });
    });

    setTeam(teamsArray);
    setTeamsList(teamsData);
  }, [teamsData]);

  useEffect(() => {
    const result = teamsList
      .map((team) => {
        const data = team.team_members.filter((member) => {
          return selectedMembers.includes(member) && member;
        });
        return data.length !== 0 ? { ...team, team_members: data } : {};
      })
      .filter((item) => Object.keys(item).length);

    setFilterResult(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMembers]);

  return (
    <div>
      <ContentHeader title="Teams" />

      <Filter
        isLoggedIn={isLoggedIn}
        team={team}
        selectedTeams={selectedTeams}
        setSelectedTeams={setSelectedTeams}
        selectedMembers={selectedMembers}
        setSelectedMembers={setSelectedMembers}
        employeesPhotos={employeesPhotos}
        setEmployeesPhotos={setEmployeesPhotos}
      />

      <Table
        teamsList={filterResult.length ? filterResult : teamsList}
        setTeamsList={setTeamsList}
        employeesPhotos={employeesPhotos}
      />
    </div>
  );
};

export default Teams;
